import { APPROACH } from "@/lib/site-data";

export const Approach = () => {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="bg-stone-50 py-24 md:py-32"
    >
      <div className="container-narrow">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-6">
            <div className="overline text-emerald-800 mb-5">— Approach</div>
            <h2 className="font-serif text-3xl md:text-5xl tracking-tight leading-tight text-slate-950">
              Four stages.<br />Zero surprises.
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-slate-600 text-base md:text-lg leading-relaxed">
              A method refined across 120+ engagements. Every milestone has a
              named owner, a written deliverable and a board-visible outcome.
            </p>
          </div>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
          {APPROACH.map((a) => (
            <li
              key={a.step}
              data-testid={`approach-step-${a.step}`}
              className="bg-white p-8 md:p-10"
            >
              <div className="font-serif text-4xl text-emerald-800 mb-6">
                {a.step}
              </div>
              <h3 className="font-serif text-xl md:text-2xl tracking-tight text-slate-950 mb-3">
                {a.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">{a.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Approach;
